const CustomProductLoanActionTypes = {
	ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_START: 'add_custom_product_loan_proposal_start',
	ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_SUCCESS: 'add_custom_product_loan_proposal_success',
	ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_FAILURE: 'add_custom_product_loan_proposal_failure',
	ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET:
		'add_custom_product_loan_proposal_response_reset',
	ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED:
		'add_custom_product_loan_proposal_response_changed',

	UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_START: 'update_custom_product_loan_proposal_start',
	UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_SUCCESS: 'update_custom_product_loan_proposal_success',
	UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_FAILURE: 'update_custom_product_loan_proposal_failure',
	UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET:
		'update_custom_product_loan_proposal_response_reset',
	UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED:
		'update_custom_product_loan_proposal_response_changed',

	FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_START: 'fetch_custom_product_loan_details_start',
	FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_SUCCESS: 'fetch_custom_product_loan_details_success',
	FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_FAILURE: 'fetch_custom_product_loan_details_failure',
	FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_RESPONSE_RESET:
		'fetch_custom_product_loan_details_response_reset',
	FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_RESPONSE_CHANGED:
		'fetch_custom_product_loan_details_response_changed',
};
export default CustomProductLoanActionTypes;
